// extracted by mini-css-extract-plugin
export default {"FifaLogo":"NotFound_FifaLogo__3PW4q","NotFoundContainer":"NotFound_NotFoundContainer__mV7cu","Text":"NotFound_Text__ySVUo"};